import styled from 'styled-components';
import { Dialog } from 'cdk-radial';

export const StyledDialog = styled(Dialog)`
  width: -webkit-fill-available;
  width: -moz-available;
`;
